const $ = require('jquery');
const _ = require('lodash');
const Slider = require('./slider');
require('jquery-inview/jquery.inview.min');
require('./ga');

import Cookies from 'js-cookie';

$(function () {
  var burger, menu, body, html, languageInMenu, loginMenu, cookieWarningDisplayed;
  burger = $('.oc-menu_burger');
  menu = $('.oc-menu');
  body = $('.oc-body');
  html = $('html');
  cookieWarningDisplayed = false;
  languageInMenu = $('.oc-menu_language');
  loginMenu = $('.oc-menu_login');
  var player;
  var thirdPartyTimestamp = '';
  $('.oc-section_intro-video .oc-button').hide();
  $('.oc-menu__logged-in-menu').hide();

  // This function is called by YouTube once the the API is ready. It creates an <iframe> and sets up the video player inside.
  window.onYouTubeIframeAPIReady = function () {
    player = new YT.Player('player');
    return player;
  };
  fetchThirdPartyCookies().then(removeCookieWarningContainer);

  fetchThirdPartyText();

  // Opening and closing nav
  burger.on('click', function (event) {
    if (!menu.hasClass('oc-menu--open')) {
      openMenu();
    } else {
      closeMenu();
    }
    event.stopPropagation();
  });

  languageInMenu.on('click', function (event) {
    toggleElementByIsActiveCls('.oc-menu_submenu-language');
    toggleElementByIsActiveCls('.oc-menu_language-icon');

    event.stopPropagation();
    event.preventDefault();
  });

  $('.oc-menu_submenu-login .oc-button').on('click', function () {
    window.open('/login', '_self');
  });

  loginMenu.on('click', function (event) {
    var mq = window.matchMedia('(max-width: 949px)');

    if (mq.matches) {
      event.stopPropagation();
      toggleElementByIsActiveCls('.oc-menu_submenu-login');
      toggleElementByIsActiveCls('.oc-menu_login-icon');
    }
  });

  function getMyAccountData() {
    var settings = {
      url: '/api/auth/user/whoami',
      method: 'GET',
      headers: {
        Accept: 'application/json, text/plain, */*',
        'X-AUTH-TOKEN': localStorage.getItem('shop.user.jwt'),
      },
    };

    $.ajax(settings).done(function (response) {
      if (!response.count) {
        return;
      }

      $('.mc-icon-user').addClass('logged-in');
      $('.oc-menu__logged-in-menu').show();
      $('.oc-menu__logged-out-menu').hide();

      const data = response.mainObjects[0];
      $('.oc-menu__user-name').text(data.fullname);
      $('.oc-menu__logout-name').text(data.fullname);
    });
  }

  $('.oc-menu__logout-link').on('click', function () {
    var settings = {
      url: '/api/auth/shop/logout',
      method: 'POST',
      headers: {
        Accept: 'application/json, text/plain, */*',
        'X-AUTH-TOKEN': localStorage.getItem('shop.user.jwt'),
      },
    };

    $.ajax(settings).done(function (response) {
      if (response.success) {
        $('.mc-icon-user').removeClass('logged-in');
        $('.oc-menu__logged-in-menu').hide();
        $('.oc-menu__logged-out-menu').show();
      }
    });
  });

  $(window).on('resize', function () {
    if (cookieWarningDisplayed && window.innerWidth < 950) {
      $('body').addClass('no-scroll');
    } else if (cookieWarningDisplayed && window.innerWidth >= 950) {
      $('body').removeClass('no-scroll');
    }
  });

  getMyAccountData();

  body.ontouchend = function (event) {
    closeMenu();
    event.stopPropagation();
    event.preventDefault();
  };

  body.on('click', function () {
    closeMenu();
  });

  document.addEventListener(
    'touchend',
    function (e) {
      if (!e.target.className.includes('menu')) {
        closeMenu();
      }
    },
    false,
  );

  showStickyMenu(menu);
  $(window).on(
    'scroll',
    _.throttle(function (e) {
      e.stopPropagation();

      // Sticky nav
      showStickyMenu(menu);

      // Test graphs
      $('.oc-section_feature-bar').one('inview', function (event, isInView) {
        $(this).removeClass('suppress-feature-bar-animation');
      });
    }, 100),
  );

  // Create Slider instances
  Slider.buildSlider('.swiper-container', Slider.getDefaultConfig());
  Slider.buildSlider('.swiper-container-secondary', Slider.getDefaultConfig());
  Slider.buildSlider('.swiper-container-industry', Slider.getDefaultConfig());
  Slider.buildSlider('.swiper-container-alloy', Slider.getDefaultConfig());

  // Open Video Container
  $('.oc-section_intro-video button').on('click', function () {
    $('.oc-section_intro-video-container').show();
    $('body').addClass('no-scroll');
    player.playVideo();
  });

  $('.close, .oc-section_intro-video-container').on('click', function () {
    $('.oc-section_intro-video-container').hide();
    $('body').removeClass('no-scroll');
    player.stopVideo();
  });

  $(document).on('keyup', function (e) {
    if (e.key === 'Escape') {
      closeCookieDialog();
      $('.close').trigger('click');

      if ($('.oc-menu_submenu-language').hasClass('is-active')) {
        toggleElementByIsActiveCls('.oc-menu_submenu-language');
        toggleElementByIsActiveCls('.oc-menu_language-icon');
      }
    }
  });

  // Smooth Scrolling
  $('a[href*="#"]').on('click', function (e) {
    e.preventDefault();
    var id = $(this).attr('href').replace(/^\//g, '');
    var marginTop = $(id).css('margin-top').replace('px', '');
    var paddingTop = $(id).css('padding-top').replace('px', '');
    var scrollTo = 0;

    if (marginTop < 0) {
      // container has negative margin top
      scrollTo = $(id).offset().top + parseInt(marginTop) + parseInt(paddingTop) + 8;
      // scrollTo = parseInt($(id).offset().top) + parseInt(marginTop);
    } else {
      // container has positive margin top
      scrollTo = $(id).offset().top - parseInt(marginTop) + 8;
    }

    $('html, body').animate(
      {
        scrollTop: scrollTo,
      },
      500,
      'linear',
    );
  });

  // Cookie warning
  function removeCookieWarningContainer() {
    const acceptedCookies = Cookies.get('ALZURA_SHOP_COOKIE_CONSENT');

    if (!acceptedCookies || !acceptedCookies.length) {
      $('.oc_cookie-warning').css('display', 'flex');

      if (window.innerWidth <= 950) {
        $('body').addClass('no-scroll');
      }

      cookieWarningDisplayed = true;

      return;
    }

    if (acceptedCookies.includes('statistical_ga')) {
      enableGoogleAnalytics();
    }

    if (acceptedCookies.includes('thirdParty')) {
      enableGoogleTagManager();
      $('.oc-section_intro-video .oc-button').show();
      enableYouTube();
    }

    $('body').removeClass('no-scroll');
    cookieWarningDisplayed = false;

    $('.oc_cookie-warning__wrapper').remove();
  }

  function fetchThirdPartyCookies() {
    return $.get(`/api/communication/expert-tracking-code`, (response) => {
      const timestamp = Cookies.get('ALZURA_SHOP_THIRDPARTY_TIMESTAMP');
      thirdPartyTimestamp = response.lastUpdated;
      if (timestamp !== response.lastUpdated) {
        Object.keys(Cookies.get()).forEach((cookie) => {
          Cookies.remove(cookie);
        });
        document.cookie = 'ALZURA_SHOP_COOKIE_CONSENT' + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
      }
    });
  }

  function toggleElementByIsActiveCls(elem) {
    $(elem).each(function (index) {
      if ($(this).hasClass('is-active')) {
        $(this).removeClass('is-active');
      } else {
        $(this).addClass('is-active');
      }
    });
  }

  function openMenu() {
    menu.addClass('oc-menu--open');
    body.addClass('oc-body--menu-open');
    html.addClass('oc-body--menu-open');
  }

  function closeMenu() {
    menu.removeClass('oc-menu--open');
    body.removeClass('oc-body--menu-open');
    html.removeClass('oc-body--menu-open');
  }

  function showStickyMenu($menu) {
    var scroll = $(window).scrollTop();
    let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
    let scrollThreshold;

    if (vw <= 991) {
      scrollThreshold = 24;
    } else {
      scrollThreshold = 48;
    }

    if (scroll > scrollThreshold) {
      $menu.addClass('oc-menu--sticky');
    } else {
      $menu.removeClass('oc-menu--sticky');
    }
  }
  // COOKIE CONSENT HANDLING
  // cookie container actions
  $('.oc_cookie-warning-edit').on('click', () => {
    $('.oc_dialog-container').addClass('is-active');
    $('body').addClass('no-scroll');
    // outside click
    setTimeout(() => {
      $(document).on('click', ({ target }) => {
        if (!target.closest('.oc_dialog-window')) {
          closeCookieDialog();
        }
      });
    });
  });

  function closeCookieDialog() {
    $('.oc_dialog-container').removeClass('is-active');
    // unbind outside click eventListener
    if (cookieWarningDisplayed && window.innerWidth < 950) {
      $('body').addClass('no-scroll');
    }
    if (cookieWarningDisplayed && window.innerWidth >= 950) {
      $('body').removeClass('no-scroll');
    }
    if(cookieWarningDisplayed === false){
      $('body').removeClass('no-scroll');
    }
    $(document).off('click');
  }

  $('.oc_dialog-close-btn').on('click', () => {
    closeCookieDialog();
  });

  // toggle details
  $('.oc_cookie-consent-settings-show-necessary-detail').on('click', () => {
    $('.oc_cookie-consent-settings-details-content-necessary').addClass(
      'oc_cookie-consent-settings-details-content--active',
    );

    $('.oc_cookie-consent-settings-show-necessary-detail').css('display', 'none');
    $('.oc_cookie-consent-settings-hide-necessary-detail').css('display', 'block');
  });

  $('.oc_cookie-consent-settings-hide-necessary-detail').on('click', () => {
    $('.oc_cookie-consent-settings-details-content-necessary').removeClass(
      'oc_cookie-consent-settings-details-content--active',
    );

    $('.oc_cookie-consent-settings-hide-necessary-detail').css('display', 'none');
    $('.oc_cookie-consent-settings-show-necessary-detail').css('display', 'block');
  });

  $('.oc_cookie-consent-settings-show-statistical-detail').on('click', () => {
    $('.oc_cookie-consent-settings-details-content-statistical-ga').addClass(
      'oc_cookie-consent-settings-details-content--active',
    );

    $('.oc_cookie-consent-settings-details-content-statistical-uservisit').addClass(
      'oc_cookie-consent-settings-details-content--active',
    );

    $('.oc_cookie-consent-settings-show-statistical-detail').css('display', 'none');
    $('.oc_cookie-consent-settings-hide-statistical-detail').css('display', 'block');
  });

  $('.oc_cookie-consent-settings-hide-statistical-detail').on('click', () => {
    $('.oc_cookie-consent-settings-details-content-statistical-ga').removeClass(
      'oc_cookie-consent-settings-details-content--active',
    );

    $('.oc_cookie-consent-settings-details-content-statistical-uservisit').removeClass(
      'oc_cookie-consent-settings-details-content--active',
    );

    $('.oc_cookie-consent-settings-hide-statistical-detail').css('display', 'none');
    $('.oc_cookie-consent-settings-show-statistical-detail').css('display', 'block');
  });

  $('.oc_cookie-consent-settings-show-third-party-detail').on('click', () => {
    $('.oc_cookie-consent-settings-details-content-third-party').addClass(
      'oc_cookie-consent-settings-details-content--active',
    );

    $('.oc_cookie-consent-settings-show-third-party-detail').css('display', 'none');
    $('.oc_cookie-consent-settings-hide-third-party-detail').css('display', 'block');
  });

  $('.oc_cookie-consent-settings-hide-third-party-detail').on('click', () => {
    $('.oc_cookie-consent-settings-details-content-third-party').removeClass(
      'oc_cookie-consent-settings-details-content--active',
    );

    $('.oc_cookie-consent-settings-hide-third-party-detail').css('display', 'none');
    $('.oc_cookie-consent-settings-show-third-party-detail').css('display', 'block');
  });
  // end toggle details

  // Cookie handling - checkboxes
  $('#statistical').on('click', () => {
    if ($('#statistical').is(':checked')) {
      $('#statisticalGA').prop('checked', true);
      $('#statisticalUserVisit').prop('checked', true);
    }

    if (!$('#statistical').is(':checked')) {
      $('#statisticalGA').prop('checked', false);
      $('#statisticalUserVisit').prop('checked', false);
    }
  });

  // Cookie handling buttons
  $('.oc_dialog-accept-selected').on('click', (event) => {
    let acceptCookies = ['necessary'];
    if ($('#statisticalGA').is(':checked')) {
      acceptCookies.push('statistical_ga');
    }

    if ($('#statisticalUserVisit').is(':checked')) {
      acceptCookies.push('statistical_internal');
    }

    if ($('#thirdParty').is(':checked')) {
      acceptCookies.push('thirdParty');
    }

    document.cookie = `ALZURA_SHOP_COOKIE_CONSENT=${JSON.stringify(acceptCookies)}`;
    Cookies.set('ALZURA_SHOP_THIRDPARTY_TIMESTAMP', thirdPartyTimestamp, { expires: 365 });
    removeCookieWarningContainer();
    closeCookieDialog(event);
  });

  $('.oc_dialog-accept-all, .oc_cookie-warning-accept').on('click', () => {
    const acceptCookies = ['necessary', 'statistical_internal', 'statistical_ga', 'thirdParty'];

    document.cookie = `ALZURA_SHOP_COOKIE_CONSENT=${JSON.stringify(acceptCookies)}`;
    Cookies.set('ALZURA_SHOP_THIRDPARTY_TIMESTAMP', thirdPartyTimestamp, { expires: 365 });
    removeCookieWarningContainer();
    closeCookieDialog();
  });

  $('.oc_cookie-warning-accept-only-necessary').on('click', () => {
    const acceptCookies = ['necessary'];

    document.cookie = `ALZURA_SHOP_COOKIE_CONSENT=${JSON.stringify(acceptCookies)}`;
    Cookies.set('ALZURA_SHOP_THIRDPARTY_TIMESTAMP', thirdPartyTimestamp, { expires: 365 });
    removeCookieWarningContainer();
  });

  function enableGoogleAnalytics() {
    let tag = document.createElement('script');
    tag.src = 'https://www.googletagmanager.com/gtag/js?id=G-QK5DFM7YYW';
    tag.async = true;

    tag.onload = () => {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-QK5DFM7YYW');
    }

    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  function enableGoogleTagManager() {
    (function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-K84HCTP');
  }

  function enableYouTube() {
    const wrapper = document.querySelector('.player-wrapper');

    let iframe = document.createElement('iframe');
    iframe.id = 'player';
    iframe.frameborder = '0';
    iframe.allowfullscreen = '1';
    iframe.allow = 'autoplay; encrypted-media';
    iframe.title = 'YouTube video player';
    iframe.width = '1920';
    iframe.height = '1080';
    iframe.src = wrapper.dataset.src;

    wrapper.appendChild(iframe);

    // This code loads the IFrame Player API code asynchronously. This is the Youtube-recommended script loading method
    let tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';

    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  function fetchThirdPartyText() {
    const thirdPartTextMap = {
      en_US: 'An unknown error occurred',
      de_DE: 'Ein unbekannter Fehler ist aufgetreten',
      es_ES: 'Ocurrió un error desconocido',
      fr_FR: "Une erreur inconnue s'est produite",
      it_IT: 'Si è verificato un errore sconosciuto',
      nl_NL: 'Er is een onbekende fout opgetreden',
      pl_PL: 'Wystąpił nieznany błąd',
    }
    let thirdPartyText = '';

    $.get(`/api/communication/setting/config/${getLocale()}`, (response) => {
      if (response.scalar && response.scalar.EXPERT_TRACKING_CODE_DESCRIPTION) {
        thirdPartyText = response.scalar.EXPERT_TRACKING_CODE_DESCRIPTION.processed || '';
      } else {
        thirdPartyText = thirdPartTextMap[getLocale()];
      }

      $('.oc_cookie-consent-settings-details-content-third-party').html(thirdPartyText);
    });
  }

  function getLocale() {
    const localeMap = {
      en: 'en_US',
      es: 'es_ES',
      fr: 'fr_FR',
      it: 'it_IT',
      nl: 'nl_NL',
      pl: 'pl_PL',
    };

    const match = window.document.location.pathname.match(/^\/([a-z]{2})\//);

    if (match && localeMap[match[1]]) {
      return localeMap[match[1]];
    }

    return 'de_DE';
  }

  function getPackagePricesAndProvisions() {
  const packageIds = ['basic', 'professional', 'enterprise', 'student'];

  packageIds.forEach(packageId => {
    // Prepare URLs for package and plugin requests
    const packageFilter = {
      packageId: {
        $eq: packageId
      },
      industryId: {
        $eq: 'none'
      }
    };

    const packageUrl = `/api/tenant/package?$filter=${encodeURIComponent(JSON.stringify(packageFilter))}`;
    const adFreePluginUrl = `/api/tenant/plugin-bundle/info/none/${packageId}/standard`;

    // Fetch additional adFree plugin information
    $.get(adFreePluginUrl)
      .done((res) => {
        const adFreePluginPrice = res.mainObjects[0].bundle_price_net / 100;
        const $adFreeItem = $(`.oc-section_pricebox-list-item--${packageId}`);

        $adFreeItem.html((_, oldHtml) => {
          return oldHtml.replace(/—/, adFreePluginPrice);
        });
      })
      .fail(() => {
        const $adFreeItem = $(`.oc-section_pricebox-list-item--${packageId}`);
        $adFreeItem.remove();
      });

    // Fetch package pricing information
    $.get(packageUrl)
      .done((response) => {
        const price = response.mainObjects[0].monthlyFee / 100;
        const provision = response.mainObjects[0].commissionRateFixed;

        const $priceBox = $(`.oc-section_pricebox-price--${packageId}`);
        const $provisionBox = $(`.${packageId}-provision`);

        // Clean up text nodes before <sup>
        $priceBox
          .contents()
          .filter(function() {
            return this.nodeType === 3;
          })
          .remove();

        // Handle price rendering
        renderPrice($priceBox, price);

        // Replace provision text
        $provisionBox.html((_, oldHtml) => {
          return oldHtml.replace(/-/, provision);
        });
      })
      .fail(() => {
        const $priceBox = $(`.oc-section_pricebox-price--${packageId}`);
        const $provisionBox = $(`.${packageId}-provision`);

        // Set price to dash
        $priceBox.text('-');

        // Remove the entire provision box
        $provisionBox.remove();
      });
    });
  }

  // Price rendering logic
  function renderPrice($priceBox, price) {
    // Special handling for cent prices
    if (price.toString().startsWith('0')) {
        // Split the price into whole number and decimal parts
        const [whole, decimal] = price.toFixed(2).split('.');

        // Clear existing content
        $priceBox.empty();

        // Create the special zero price structure
        $('<span>').text('0').appendTo($priceBox);
        $('<sup>').text(decimal).appendTo($priceBox);
        $('<sup>').text('€').appendTo($priceBox);
    } else {
        const $sup = $priceBox.find('sup');
        if ($sup.length) {
            $('<span>')
                .text(price)
                .insertBefore($sup);
        }
    }
  }

  getPackagePricesAndProvisions();


  // Handle updating the locale of the accessibility widget
  window.addEventListener("load", () => {
    window.changeAccessibilityWidgetLocale(getLocale());
    window.applyStoredAdjustmentsOfAccessibilityWidget();
  });
});
